import React from "react";
import { CustomTable, useFormatAmount } from "../../../shared";

export const AgedSummary = ({ data = [] }) => {
  const formatAmount = useFormatAmount();

  const columnsAndData = React.useMemo(() => {
    const columns = data.map((item) => ({
      Header: item.label,
      accessor: item.label,
      Cell: ({ value }) => formatAmount(value),
    }));

    const rowData = data.reduce((acc, item) => {
      acc[item.label] = item.amount;
      return acc;
    }, {});

    return { columns, data: columns.length > 0 ? [rowData] : [] };
  }, [data, formatAmount]);

  return (
    <CustomTable
      tableTitle="Aged Summary"
      columns={columnsAndData?.columns}
      data={columnsAndData?.data}
      defaultSearch={false}
      searchBar={false}
      pagination={false}
    />
  );
};
